var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.5C7.40625 20.5 4.125 18.625 2.32812 15.5C0.53125 12.4141 0.53125 8.625 2.32812 5.5C4.125 2.41406 7.40625 0.5 11 0.5C14.5547 0.5 17.8359 2.41406 19.6328 5.5C21.4297 8.625 21.4297 12.4141 19.6328 15.5C17.8359 18.625 14.5547 20.5 11 20.5ZM11 5.5C10.4531 5.5 10.0625 5.92969 10.0625 6.4375V10.8125C10.0625 11.3594 10.4531 11.75 11 11.75C11.5078 11.75 11.9375 11.3594 11.9375 10.8125V6.4375C11.9375 5.92969 11.5078 5.5 11 5.5ZM9.75 14.25C9.75 14.9531 10.2969 15.5 11 15.5C11.6641 15.5 12.25 14.9531 12.25 14.25C12.25 13.5859 11.6641 13 11 13C10.2969 13 9.75 13.5859 9.75 14.25Z",
    fill: "#E2001A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.33707c60638313cbb46bdbb6a605adba.svg";
export { ForwardRef as ReactComponent };